import React, {useEffect, useState} from "react";
import Section1 from "../../components/Section1";
import LayoutsList from "../../components/LayoutsList";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { apiUrl, assetsUrl } from "../../config/Config";
import axios from "axios";

import googleicon from '../../assets/images/google_icon.png';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";

const ResetPassword = () => {
    let navigate = useNavigate();

    const [fullname, setfullname] = useState("");
    const [emailaddress, setemailaddress] = useState("");
    const [phonenumber, setphonenumber] = useState("");
    const [password, setpassword] = useState("");
    const [repassword, setrepassword] = useState("");

    const [showloading, setshowloading] = useState(false);

    const [passworderrormessage, setpassworderrormessage] = useState("");
    const [repassworderrormessage, setrepassworderrormessage] = useState("");
    const [mismatchpassworderrormessage, setmismatchpassworderrormessage] = useState("");

    const { state } = useLocation();

    console.log('ResetPassword state >>', state)

    const handlesignupfunc = async() => {
        // navigate('/verify-email-address')
        console.log('state >>', state?.emailaddress)
        var ispassworderror = false;
        var isrepassworderror = false;
        var ismismatchpassworderror = false;

        if (password) {
          ispassworderror = false;
          setpassworderrormessage("");
        } else {
          ispassworderror = true;
          setpassworderrormessage("Enter Password.");
        }
    
        if (repassword) {
          isrepassworderror = false;
          setrepassworderrormessage("");
        } else {
          isrepassworderror = true;
          setrepassworderrormessage("Enter Re-Password.");
        }
    
        if (
          !ispassworderror &&
          !isrepassworderror &&
          !ismismatchpassworderror
        ) {
          if (password == repassword) {
            console.log("validation passed!!");
            ismismatchpassworderror = false;
            setmismatchpassworderrormessage("");
          } else {
            ismismatchpassworderror = true;
            setmismatchpassworderrormessage(
              "Password & Re-password does not match!!"
            );
            return;
          }
        } else {
          console.log("validation failed!!");
          // alert("validation failed!!");
          return;
        }

        var data = {
          emailaddress: state?.emailaddress,
          password: password,
        }
        console.log('data >>', data);

        setshowloading(true);
      
        try {
          const res = await axios.post(
            apiUrl + "user-updatepassword-with-email",
            data,
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          );
      
          if (res.data.status === "success") {
            setshowloading(false);
            
            navigate('/login');
      
          } else {
            setshowloading(false);
            alert(res.data.message || "Something went wrong.");
          }
        } catch (err) {
          setshowloading(false);
          console.error(err);
          alert(
            "Error logging in: " +
              (err.response?.data?.message || err.message || "Network error.")
          );
        } finally {
          // setLoading(false);
          setshowloading(false);
        }
    }

    const resendotpfunc = () => {
      navigate('/verify-email-address', {
        state: {
          semail: emailaddress,
          screen: "resset-password"
        }
      } )
    }
    

    return (
      <div className="homepage-layout">
        <section>
          <div className=" findlayout_section1main regsiterpagemaindiv">
            <div className="container">
              <div className="registermaindiv">
                <p className="section1title">
                  <span className="gradient-head">Reset Password</span>
                </p>
                <div className="register-inputdiv">
                  <label>Email Address *</label>
                  <input
                    type="text"
                    value={state?.emailaddress}
                    // onChange={(t) => {
                    //   setemailaddress(t.target.value);
                    // }}
                    disabled
                    className="register-textinput form-control"
                    placeholder="Enter your email address"
                  />
                </div>
                <div className="register-inputdiv">
                  <label>New Password *</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(t) => {
                      setpassword(t.target.value);
                    }}
                    className="register-textinput form-control"
                    placeholder="Enter your password"
                  />
                  {passworderrormessage ? (
                      <p className="register-error-message">
                        {passworderrormessage}
                      </p>
                    ) : null}
                </div>
                <div className="register-inputdiv">
                  <label>Re-enter Password *</label>
                  <input
                    type="password"
                    value={repassword}
                    onChange={(t) => {
                      setrepassword(t.target.value);
                    }}
                    className="register-textinput form-control"
                    placeholder="Enter your re-password"
                  />
                  {repassworderrormessage ? (
                      <p className="register-error-message">
                        {repassworderrormessage}
                      </p>
                    ) : null}
                </div>

                {mismatchpassworderrormessage ? (
                <p className="register-error-message">
                  {mismatchpassworderrormessage}
                </p>
              ) : null}

                <div
                  className="registersubmitbtn"
                  onClick={() => {
                    if(showloading) {

                    } else {
                      handlesignupfunc();
                    }
                    
                  }}
                >
                  { showloading ?
                  <div className="spinnermaindiv">
                  <Spinner
                    color="#fff"
                    size={16}
                    className="spinnerCenter"
                  />
                </div> :
                <p>Submit</p>
                }
                </div>
                <br />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
}

export default ResetPassword